<template>
  <div :style="{ display: 'flex', alignItems: 'center', gap: '10px' }">
    <RenderNode :node="config.extraControls" />
    <DensitySwitch v-if="viewType === 'list'" :value="density" @change="emit('update:density', $event)" />
    <ColumnsMenu
      v-if="!config.hideOptions"
      :config="config"
      :field-meta="fieldMeta"
      :col-config="tableCols"
      @update:col-config="emit('update:tableCols', $event)"
    />
    <ViewSwitch :value="viewType" :allowed="allowedViews" @change="emit('update:viewType', $event)" />
  </div>
</template>

<script setup>
// The collection display controls (extra controls · density · Options · view),
// shown in the toolbar. Extracted from list-edit-shell.jsx `collectionControls`.
import DensitySwitch from '../collection/DensitySwitch.vue'
import ViewSwitch from '../collection/ViewSwitch.vue'
import ColumnsMenu from '../collection/ColumnsMenu.vue'
import RenderNode from '@/admin-collection-layout/lib/RenderNode.js'

defineProps({
  config: { type: Object, required: true },
  fieldMeta: { type: Object, default: () => ({}) },
  viewType: { type: String, default: 'list' },
  density: { type: String, default: 'expanded' },
  tableCols: { type: Array, default: () => [] },
  allowedViews: { type: Array, default: null },
})
const emit = defineEmits(['update:density', 'update:viewType', 'update:tableCols'])
</script>
